import React from "react";

import PageMeta from "../general/PageMeta";
import PageSections from "../sections/PageSections";

//Weddings, Birthdays, Conferences etc. - the page content comes from data/pages.js
const EventPage = ({ page }) => (
  <React.Fragment>
    <PageMeta
      title={page.title}
      description={page.description}
    />
    <PageSections sections={page.sections} />
  </React.Fragment>
);

export default EventPage;
